import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import heatmap from 'highcharts/modules/heatmap';
import { useMemo, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { asSolutionGroup, type ScreenSolutionGroup } from '../../types';
import { useAppContext } from '../../contexts/AppContext';
import { buildNpvHeatmapOptions } from '../../utils/chartOptions/npvHeatmap';

heatmap(Highcharts);

type Props = {
  name: string;
  data: ScreenSolutionGroup;
};

const HeatMapChart = ({ name, data }: Props) => {
  const { isDarkMode } = useAppContext();
  const chartComponent = useRef(null);
  const chartOptions = useMemo(() => (data ? buildNpvHeatmapOptions(asSolutionGroup(data), name) : null), [data, name]);

  return (
    <>
      <Box sx={{ justifyContent: 'center', pl: 1, pr: 1 }}>
        {chartOptions ? (
          <HighchartsReact
            ref={chartComponent}
            containerProps={{ className: isDarkMode ? 'dark-chart' : '', style: { width: '100%' } }}
            highcharts={Highcharts}
            options={chartOptions}
          />
        ) : (
          <Typography color="text.secondary">Loading chart...</Typography>
        )}
      </Box>
    </>
  );
};

export default HeatMapChart;
